// extracted by mini-css-extract-plugin
module.exports = {"header":"Accordion_header__RU93Y","disabled":"Accordion_disabled__32hYp"};